module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/business/business-category/business-category.component.css
// module id = ./src/app/components/business/business-category/business-category.component.css
// module chunks = main